import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PAGE_KEY } from "./constants";
var localePt = /*#__PURE__*/_defineProperty({}, PAGE_KEY, {
  FILTER_MOST_CONSULTED: 'Mais consultadas',
  FILTER_GENERAL: 'Geral',
  FILTER_ELEARNING: 'E-learning',
  FILTER_CLIMATE_RECOGNITION: 'Clima e reconhecimento',
  FILTER_PERFORMANCE: 'Desempenho',
  LABEL_CATEGORIES: 'Categorias',
  LABEL_CATEGORIES_TEXTAREA: 'Categorias',
  LABEL_TOOLTIP_FILTER_BUTTON: 'Categorias sugeridas',
  LABEL_FILTER_TITLE: 'Escolha uma opção para obter sugestões de consultas relacionadas'
});
export default localePt;